import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import LazyPage from "../components/base/LazyPage";


const Home = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const InitiativesPage = lazy(() => import("../pages/initiatives/page"));
const EventsPage = lazy(() => import("../pages/events/page"));
const EventDetailPage = lazy(() => import("../pages/events/detail/page"));
const StoriesPage = lazy(() => import("../pages/stories/page"));
const StoryDetailPage = lazy(() => import("../pages/stories/detail/page"));
const SupportPage = lazy(() => import("../pages/support/page"));
const MemberPage = lazy(() => import("../pages/support/member/page"));
const VolunteerPage = lazy(() => import("../pages/support/volunteer/page"));
const DonatePage = lazy(() => import("../pages/support/donate/page"));
const CooperatePage = lazy(() => import("../pages/cooperate/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const PrivacyPage = lazy(() => import("../pages/privacy/page"));

const routes: RouteObject[] = [
  { path: "/", element: <LazyPage component={Home} /> },
  { path: "/about", element: <LazyPage component={AboutPage} /> },
  { path: "/initiatives", element: <LazyPage component={InitiativesPage} /> },
  { path: "/events", element: <LazyPage component={EventsPage} /> },
  { path: "/events/:id", element: <LazyPage component={EventDetailPage} /> },
  { path: "/stories", element: <LazyPage component={StoriesPage} /> },
  { path: "/stories/:id", element: <LazyPage component={StoryDetailPage} /> },
  { path: "/support", element: <LazyPage component={SupportPage} /> },
  { path: "/support/member", element: <LazyPage component={MemberPage} /> },
  { path: "/support/volunteer", element: <LazyPage component={VolunteerPage} /> },
  { path: "/support/donate", element: <LazyPage component={DonatePage} /> },
  { path: "/cooperate", element: <LazyPage component={CooperatePage} /> },
  { path: "/contact", element: <LazyPage component={ContactPage} /> },
  { path: "/privacy", element: <LazyPage component={PrivacyPage} /> },

  // Old URL redirects
  { path: "/join", element: <Navigate to="/support" replace /> },
  { path: "/news", element: <Navigate to="/events" replace /> },
  { path: "/na", element: <Navigate to="/stories" replace /> },
  { path: "/index/*", element: <Navigate to="/" replace /> },

  { path: "*", element: <LazyPage component={NotFound} /> },
];

export default routes;